import CommonNav from 'core/CommonNav';
import FullWrapper from 'core/FullWrapper';

import cn from './style.module.sass';

type BannerCaseNavProps = {
    caseType: string;
    isCase?: boolean;
};

const BannerCaseNav = ({ caseType, isCase }: BannerCaseNavProps) => {
    return (
        <FullWrapper className={cn.navigation}>
            <CommonNav
                stepOne="Главная"
                stepTwo={isCase ? 'Кейсы' : 'Проекты'}
                stepThree={caseType}
                className="nav--cases"
                link1="/"
                link2="/cases"
                link3={caseType}
            />
        </FullWrapper>
    );
};
export default BannerCaseNav;
